// 電話番号の形式（ハイフン無し・0 始まりの 10・11 桁）。サーバー側の検証は app/models/address.rb の tel。
const TEL_PATTERN = /^0\d{9,10}$/;
const TEL_MESSAGE =
  '「0」から始まる 10桁 または 11桁 の電話番号をハイフン無しで入力してください';
export {TEL_PATTERN, TEL_MESSAGE};
